module.exports = __webpack_public_path__ + "img/Lobby_Banner2.f989c8bd.jpg";